import { Module } from '#/shared/types';

export const NotificationSettingValue = {
  Off: 0,
  All: 1,
  Self: 2
} as const;

export type NotificationSettingValue =
  (typeof NotificationSettingValue)[keyof typeof NotificationSettingValue];

export const NotificationType = {
  DocumentShare: 1,
  DocumentComment: 2,
  DocumentMention: 3,
  DirectoryShare: 200,
  ProjectShare: 400,
  TaskCreated: 401,
  TaskDeleted: 402,
  TaskUpdated: 403,
  TaskMoved: 404,
  TaskStatusChanged: 405,
  TaskCommentAdded: 406,
  MyTaskDeleted: 420,
  MyTaskUpdated: 421,
  MyTaskMoved: 422,
  MyTaskStatusChanged: 423,
  MyTaskCommentAdded: 424,
  UnassignedFromTask: 425,
  AssignedToTask: 426,
  TaskCommentMention: 427,
  TaskAttachmentAdded: 429,
  SprintCreated: 450,
  RoleAssigned: 500,
  RoleDeleted: 501,
  ImportantNewEmailMessage: 550,
  NewEmailMessage: 551,
  CalendarShare: 600,
  CalendarEventCancel: 601,
  CalendarEventInvite: 602,
  CalendarEventChange: 603,
  CalendarUpcomingEvent: 604,
  RoomShare: 201
} as const;

export type NotificationType = (typeof NotificationType)[keyof typeof NotificationType];

export type NotificationSetting = {
  id: NotificationType;
  notificationType: NotificationType;
  value: NotificationSettingValue;
  source: Module;
};
